<template lang="pug">
  #media
    .items
      router-link#digitanz.item(to="/")
        h1 #digitanz
      .item(v-for="item in items" :class="{active: item === activeItem, 'has-bg': !!(item.src), 'slide-in': slideIn}" :style="{'background-image': `url(${item.src})`}")
        a(@click="setActiveItem(item)")
          template(v-if="!item.src") {{item.title.slice(0,1).toLowerCase()}}
          template(v-else) {{decodeURIComponent('&nbsp;')}}
    component.active-item(v-if="activeItem" :is="activeItem.component || 'html-dump'")
      .items
        a#digitanz.item(@click="removeActiveItem")
          h1 #digitanz
        .item(v-for="item in items" :class="{active: item === activeItem, 'has-bg': !!(item.src), 'slide-in': slideIn}" :style="{'background-image': `url(${item.src})`}")
          a(@click="setActiveItem(item)")
            template(v-if="!item.src") {{item.title.slice(0,1).toLowerCase()}}
            template(v-else) {{decodeURIComponent('&nbsp;')}}
        .item.close-button
          a(@click="removeActiveItem") {{$t('labels.close').toLowerCase()}}
      .content(v-if="activeItem.html" v-html="activeItem.html")
</template>

<script>
import HtmlDump from './fragments/HtmlDump'
export default {
  components: {
    HtmlDump
  },
  name: 'MediaComponent',
  data () {
    return {
      items: [],
      activeItem: null,
      slideIn: false
    }
  },
  mounted () {
    const that = this
    this.$eventbus.$on('set-media-elements', this.newItems)
    window.addEventListener('keyup', event => {
      if (that.activeItem) {
        if (event.code === 'Escape') {
          that.removeActiveItem()
        } else if (event.code === 'ArrowRight') {
          that.changeActiveItem(1)
        } else if (event.code === 'ArrowLeft') {
          that.changeActiveItem(-1)
        }
      }
    })
  },
  methods: {
    async newItems (items) {
      this.slideIn = false
      this.items = items
      this.activeItem = false
      window.setTimeout(evt => {
        this.slideIn = true
      }, 250)
    },
    setActiveItem (item) {
      this.removeActiveItem()
      this.activeItem = item
      item.active = true
    },
    removeActiveItem () {
      this.items.forEach(i => { i.active = false })
      this.activeItem = null
    },
    changeActiveItem (dir = 1) {
      if (this.activeItem && !isNaN(+(dir))) {
        let i = this.items.indexOf(this.activeItem) + dir
        if (i < 0) {
          i = this.items.length - (Math.abs(i) % this.items.length)
        } else {
          i = i % this.items.length
        }
        this.items.forEach(i => { i.active = false })
        this.activeItem = this.items[i]
      }
    }
  }
}
</script>

<style scoped lang="stylus">
@import '../css/vars'

#media
  width 100vw
  min-height 4rem

  overflow hidden
  overflow -moz-scrollbars-none
  -ms-overflow-style none
  scrollbar-width none
  &::-webkit-scrollbar
    display none

  overflow-x scroll

  .items
    padding-left 1.5rem
    white-space nowrap

    .item
      display inline-block
      border 3px solid $color-font-dark-gray
      border-radius 3rem
      margin-right 0.5rem
      // background-color $color-font-light-gray
      background-size cover
      overflow hidden

      margin-left 90vw
      transition margin-left 0.2s ease-out

      &.slide-in
        margin-left 0rem

      a
        border-radius 3rem
        box-sizing border-box
        border 0px solid $color-bg-light-gray
        transition border-width 0.1s ease-in

      & > *
        display flex
        flex-direction row
        justify-content center
        align-items center
        min-width 4rem
        min-height 4rem
        font-size 1.6rem

        @media screen and (max-width: $media-query-width-laptop)
          min-width auto
          min-height auto
          width 2rem
          height 2rem
          font-family 'Chivo', sans-serif
          font-size 1.2rem
          font-weight 400

      &:hover
      &.active
        color $color-bg-light-gray
        background-color $color-font-dark-gray

        a
          border-width 3px

      /* &.has-bg:hover
      &.has-bg.active
        a
          background-color rgba(0, 0, 0, 0.6) */

  .active-item
    height 100vh
    position absolute
    top 0
    left 0
    bottom 0
    right 0
    z-index 999
    background-color $color-font-dark-gray

    .items
      overflow-x scroll
      padding 1rem
      padding-bottom 0.5rem
      background-color $color-bg-light-gray
      border-bottom 1px solid $color-font-medium-gray

      .close-button
        color $color-font-light-gray
        border-color $color-font-light-gray
        background-color $color-bg-light-gray
        margin-left 0.5rem

    .content
      width 100vw
      height calc(calc(var(--vh, 1vh) * 100) - 6rem)
      overflow auto
      position relative
      display flex
      flex-direction column
      justify-content center
      align-items center

      @media screen and (max-width: $media-query-width-laptop)
        height calc(calc(var(--vh, 1vh) * 100) - 4.3rem)

  #digitanz
    padding-left 1.1rem
    padding-right 1.1rem
    background-color $color-bg-light-gray
    color $color-font-dark-gray
    margin-right 1rem
    margin-left 0rem

    h1
      width auto

    &:hover
      background-color $color-font-dark-gray
      color $color-bg-light-gray

    @media screen and (max-width: $media-query-width-laptop)
      padding-left 0.8rem
      padding-right 0.8rem

      h1
        font-size 1.2rem

</style>



// WEBPACK FOOTER //
// src/components/MediaComponent.vue